export const profile = {
  name: 'Arisa Nemoto',
  tagline: 'AI Engineer / Violinist',
  location: 'Tokyo, Japan',
  email: 'ardolce23@gmail.com',
  links: {
    linkedin: 'https://www.linkedin.com/in/arisa-nemoto-533751188/',
    github: 'https://github.com/Allllisha',
  },
};

export const engineerTimeline = {
  heading: 'AI Engineer',
  subheading: 'Code that listens.',
  items: [
    {
      year: 'Now',
      title: 'AI Engineer',
      description:
        'Building LLM-powered products and conducting research at the intersection of models, data, and UX.',
    },
    {
      year: '2022',
      title: 'Le Wagon Tokyo — Web Development',
      description:
        'Completed a 24-week intensive web development bootcamp. Worked at production level with Ruby on Rails, React, JavaScript, TypeScript, and Docker.',
    },
  ],
  skills: [
    'Python',
    'LLM / RAG',
    'TypeScript',
    'React',
    'Next.js',
    'Ruby on Rails',
    'Docker',
    'SCSS',
  ],
};

export const violinistTimeline = {
  heading: 'Violinist',
  subheading: 'Music that thinks.',
  items: [
    {
      year: 'Master',
      title: 'Guildhall School of Music and Drama, UK',
      description:
        'Completed a Master’s degree at one of London’s leading conservatoires, working across classical, chamber music, and jazz.',
    },
    {
      year: 'Bachelor',
      title: 'Tokyo University of the Arts',
      description:
        'Studied violin at Japan’s top music university.',
    },
  ],
  skills: ['Classical', 'Jazz', 'Chamber Music', 'Studio Recording'],
};
